module.exports = __webpack_public_path__ + "static/img/review_application.c4b862a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/review_application.svg
// module id = M3vQ
// module chunks = 1